import React from 'react';

function ContentCard({
  className = '',
  icon,
  stepNumber,
  stage,
  title,
  description,
  items,
  ctaLabel,
  ctaHref,
  ctaClassName = 'button blue',
  featuredBadge,
  price,
  badgeClassName = '',
  children,
}) {
  const classes = [className].filter(Boolean).join(' ');
  const isStep = typeof stepNumber !== 'undefined' && stepNumber !== null;

  return (
    <article className={classes}>
      {featuredBadge ? <span className="featured-badge">{featuredBadge}</span> : null}
      {isStep ? <span className="step-number">{stepNumber}</span> : icon ? <div className="card-icon">{icon}</div> : null}
      <div className={isStep ? 'card-body' : undefined}>
        {stage ? <span className="stage">{stage}</span> : null}
        {title ? <h4>{title}</h4> : null}
        {price ? <p className="price">{price}</p> : null}
        {description ? <p>{description}</p> : null}
        {items && items.length > 0 ? (
          <ul>
            {items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        ) : null}
        {children}
        {ctaLabel && ctaHref ? (
          <a href={ctaHref} className={ctaClassName}>
            {ctaLabel}
          </a>
        ) : null}
      </div>
    </article>
  );
}

export default ContentCard;